const actionTypes = {
    GET_COUNTRIES: 'GET_COUNTRIES',
    GET_LANGUAGES: 'GET_LANGUAGES',
    GET_PERMISSION_GROUPS: 'GET_PERMISSION_GROUPS',
};

export default actionTypes;
